let apiListUrl = JSON.parse(window.localStorage.getItem('apiListUrl'));
let WANIP='';
let device = 'pc_web';
let client = 5;//班级列表用
let version= "1.0.0";
if(LIMI_ENV==='electron'){
	device = 'pc_h5';
	client = 4;
	try {
		let packageData = nodeRequire(nodeProcess.cwd()+'/resources/app/package.json');
		version = packageData.version;
	} catch (error) {
	}
}
try {
	WANIP = returnCitySN["cip"];
} catch (error) {
	WANIP = 'IP获取失败';
}
export default {
	version: version,
	API: apiListUrl,//url接口数据
	device:device,
	LANIP:'',//内网ip
	WANIP:WANIP,//外网IP
	client:client,
	configurl :{
		desc:"生产环境",
		name:"pro",
		url:"https://api-config.zhuhuotech.com/config/studentApiList"
	},
	set(name, data) {
		window.localStorage.setItem(name, JSON.stringify(data))
	},
	get(dataName) {
		if (window.localStorage.getItem(dataName) != 'undefined') {
			return JSON.parse(window.localStorage.getItem(dataName));
		}
	},
	setSession(name, data) {
		window.sessionStorage.setItem(name, JSON.stringify(data))
	},
	getSession(dataName) {
		if (window.sessionStorage.getItem(dataName) != 'undefined') {
			return JSON.parse(window.sessionStorage.getItem(dataName));
		}
	},
	removeSession(dataName) {
		window.sessionStorage.removeItem(dataName)
	},
	remove(dataName) {
		window.localStorage.removeItem(dataName)
	},
	getTemServerTime(){
		let time =  Math.floor((window.performance.now())/1000);
		let temServerTime = this.getSession('temServerTime');
		let temClientTime = this.getSession('temClientTime');
		if(!temServerTime || !temClientTime){
			return  Math.floor(Date.now()/1000);
		}
		//console.log('当前服务器时间：',temServerTime + (time-temClientTime))
    	return temServerTime + (time-temClientTime);
	}
}








// WEBPACK FOOTER //
// ./src/js/API.js